import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { shallowEqual, useSelector } from "react-redux";
import Errors from "./Errors";
import checkErrors from "../nodes/Logic/helpers/checkErrors";
import JsonCollapse from "./JsonCollapse";

export default function ErrorsSidebar() {
  const errors = useSelector(checkErrors, shallowEqual);
  const [show, setShow] = useState(false);

  return (
    <>
      {errors.length > 0 && (
        <div className="card card-body p-2 mt-2">
          <div className="d-flex align-items-center m-0">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="text-danger me-2"
            />
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => setShow(true)}
            >
              Errors
            </button>
            <span className="flex-grow-1" />
            <span className="badge bg-secondary rounded-pill">
              {errors.length}
            </span>
          </div>
        </div>
      )}
      <Offcanvas show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Errors</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {errors.length} {errors.length === 1 ? "Error" : "Errors"}:{" "}
          <div onClick={() => setShow(false)}>
            <Errors />
          </div>
          <JsonCollapse json={errors} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
